import PropTypes from 'prop-types';
import { useState } from 'react';
import { styled, useTheme } from '@mui/styles';
import { Avatar, Grid, Menu, MenuItem, Typography } from '@mui/material';
import { Box } from '@mui/system';
import MainCard from '../../ui-component/cards/MainCard';
import { Link } from "react-router-dom";

const CardWrapper = styled(MainCard)(({ theme }) => ({
    backgroundColor: '#F44336',
    overflow: 'hidden',
    position: 'relative',
    alignItems: 'center',
    textAlign: 'center',
    height: 250,
    color: 'white',
    '&:after': {
        content: '""',
        position: 'absolute',
        width: 210,
        height: 210,
        background: '#f6b9b99a',
        borderRadius: '50%',
        top: -85,
        right: -95,
        [theme.breakpoints.down('sm')]: {
            top: -105,
            right: -140
        }
    },
    '&:before': {
        content: '""',
        position: 'absolute',
        width: 210,
        height: 210,
        background: '#f6b9b99a',
        borderRadius: '50%',
        top: -125,
        right: -15,
        opacity: 0.5,
        [theme.breakpoints.down('sm')]: {
            top: -155,
            right: -70
        }
    }
}));



// ===========================|| DASHBOARD DEFAULT - EARNING CARD ||=========================== //

const RedirectCard = ({ isLoading }) => {
    const theme = useTheme();

    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            {/* <Link to="/upload_file" style={{ textDecoration: 'none' }}> */}
                <CardWrapper border={false} content={false} className="CardWrapper" onClick={()=>{}} >
                    <Box sx={{ p: 2.25 }}>
                        <Grid container direction="column">
                            <Grid item>
                                <Grid container justifyContent="center">
                                    <Grid item>
                                        <br></br>   <br></br>   <br></br>
                                        <i style={{ color: 'white' }} className="fa-3x fa-solid fa-gear"></i>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item>
                                <Grid container justifyContent="center" alignItems="center">
                                    <Grid item>
                                        <Typography sx={{ fontSize: '1.55rem', fontWeight: 700, mr: 1, mt: 1.75, mb: 0.75 }}>
                                            Upload File
                                        </Typography>
                                    </Grid>

                                </Grid>
                            </Grid>

                        </Grid>
                    </Box>
                </CardWrapper>
            {/* </Link> */}
        </>
    );
};

RedirectCard.propTypes = {
    isLoading: PropTypes.bool
};

export default RedirectCard;
